// extracted by mini-css-extract-plugin
export var customTabs = "customtabs-module--customTabs--KqwSv";
export var productImage = "customtabs-module--productImage--W2vNa";
export var productInfoParent = "customtabs-module--productInfoParent--yB9-N";
export var selected = "customtabs-module--selected--yFcnS";
export var specs = "customtabs-module--specs--E-LfH";
export var specsContent = "customtabs-module--specsContent--NKey4";
export var specsTable = "customtabs-module--specsTable--y9qdJ";
export var specsTableKey = "customtabs-module--specsTableKey--ikSzv";
export var specsTableValue = "customtabs-module--specsTableValue--YkIPK";
export var specsTitle = "customtabs-module--specsTitle--mKLGe";
export var specsTitleText = "customtabs-module--specsTitleText--QoMj2";
export var tab = "customtabs-module--tab--2TjoT";
export var tabContent = "customtabs-module--tabContent--PAUCw";
export var tabs = "customtabs-module--tabs--TuKC3";